/**
 * Copyright Mántum All Rights Reserved.
 */
import Button from '../../button';
import Dropdown from '../../dropdown';
import Row from './row';
import useOpen from '../../../../hooks/useOpen';
import { EllipsisVerticalIcon } from '@heroicons/react/24/outline';

import type { Context, Option, Options } from '../type';

type PropTypes = {
    children?: React.ReactNode;
    onClick?: (value: Context | Option) => void;
    options?: Options;
};

export default function Body(props: PropTypes) {
    // prettier-ignore
    const {
        options = []
    } = props

    // prettier-ignore
    const {
        onToggle,
        onClose,
        value: isOpen,
    } = useOpen(false);

    return (
        <div className='relative max-w-full md:max-w-xs'>
            {options.length > 0 && (
                <Button
                    className='absolute right-0 top-1.5 rounded-md p-2 hover:bg-gray-300'
                    onClick={onToggle}
                >
                    <EllipsisVerticalIcon className='h-6 w-6' />
                </Button>
            )}
            {isOpen && (
                <Dropdown onClose={onClose}>
                    {options.map((option) => (
                        <Row
                            key={option.id}
                            value={option}
                            onClick={props.onClick}
                        />
                    ))}
                </Dropdown>
            )}
            {props.children}
        </div>
    );
}
